// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import Spinner from './Spinner'; // Importamos el componente Spinner

const ProtectedRoute = ({ children }) => {
  // --- INICIO DEL CAMBIO ---
  const { user, isAuthLoading } = useAuthContext();

  // 1. Si la autenticación aún está en proceso de verificación, mostramos un spinner.
  if (isAuthLoading) {
    // Esto previene la redirección prematura.
    return (
      <div className="flex justify-center items-center h-screen">
          <Spinner />
      </div>
    );
  }

  // 2. Una vez que isAuthLoading es false, procedemos con la lógica normal.
  // Si no hay usuario, entonces sí redirigimos al login.
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  // --- FIN DEL CAMBIO ---

  // Si la carga ha terminado y hay un usuario, mostramos el contenido protegido.
  return children;
};

export default ProtectedRoute;